module.exports = __webpack_public_path__ + "assets/a11yMenuIcon-48c769.svg";